import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Range, Direction, getTrackBackground } from 'react-range'

import { ReactComponent as MusicNoteIcon } from 'assets/svg/shared/music_note.svg'
import { ReactComponent as MusicNoteMuteIcon } from 'assets/svg/shared/music_note-mute.svg'
import { onVolumeChange } from 'store/actions/settings'
import { WhitelabelConfig } from 'hooks'
import cn from 'classnames'

const STEP = 1
const MIN = 0
const MAX = 100

export const VolumePicker = () => {
    const dispatch = useDispatch()
    const vol = useSelector((state) => state.settings.volume)
    const [finalVolume, setFinalVolume] = useState(0)
    const rangeValues = vol ? [vol] : [0]
    const pickerTrackBgColor = WhitelabelConfig.colors.primary
    const [isMuted, setIsMuted] = useState(vol === 0)

    useEffect(() => {
        const audio = new Audio('/audio/volume_bar.mp3')
        audio.volume = 0.01 * finalVolume
        audio.play()
    }, [finalVolume])

    function onChangeHandler(value) {
        dispatch(onVolumeChange({ value: value[0] }))
    }

    function onFinalChangeHandler(value) {
        setFinalVolume(value)
    }

    function onMuteHandler() {
        setIsMuted(!isMuted)
        if (vol > 0) {
            onChangeHandler([0])
        } else if (vol === 0) {
            onChangeHandler([50])
            setFinalVolume(50)
        }
    }

    return (
        <>
            <div className="app__header__vol-picker d-flex flex-column align-items-center">
                <Range
                    direction={Direction.Up}
                    values={rangeValues}
                    step={STEP}
                    min={MIN}
                    max={MAX}
                    onFinalChange={onFinalChangeHandler}
                    onChange={onChangeHandler}
                    renderTrack={({ props, children }) => (
                        <div
                            onMouseDown={props.onMouseDown}
                            onTouchStart={props.onTouchStart}
                            className="app__header__vol-picker__track d-flex"
                        >
                            <div
                                ref={props.ref}
                                style={{
                                    width: '3px',
                                    height: '100%',
                                    borderRadius: '4px',
                                    background: getTrackBackground({
                                        values: rangeValues,
                                        colors: [pickerTrackBgColor, 'rgba(235 249 245)'],
                                        min: MIN,
                                        max: MAX,
                                        direction: Direction.Up
                                    }),
                                    alignSelf: 'center'
                                }}
                            >
                                {children}
                            </div>
                        </div>
                    )}
                    renderThumb={({ props }) => (
                        <div
                            {...props}
                            className="app__header__vol-picker__thumb d-flex justify-content-center align-items-center"
                        />
                    )}
                />
            </div>
            <button type="button" onClick={onMuteHandler}>
                {vol === 0 ? (
                    <MusicNoteMuteIcon
                        width={14}
                        height={16}
                        className={cn('app__header__img-music', isMuted && 'app__header__img-music--active')}
                    />
                ) : (
                    <MusicNoteIcon
                        width={14}
                        className={cn('app__header__img-music', isMuted && 'app__header__img-music--active')}
                    />
                )}
            </button>
        </>
    )
}
